import React from "react";
import { TableCell } from "@material-ui/core";
import { Link } from "react-router-dom";
import { URLS } from "_configs/URLS";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TCompare } from "properties/compare/_models/properties-favorite.model";
import { useTranslation } from "react-i18next";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";
import { refreshPage } from "_common/_utils/pageUtils";

interface Props {
    item: TCompare;
}
export default function CompareModalTableHeader({ item }: Props) {
    const { t } = useTranslation();

    if (!item) return null;

    const itemUrl =
        item.resource === COMMON_RESOURCE.PROPERTIES
            ? URLS.property(item.urlAlias)
            : `${URLS.property(item.parentUrlAlias!)}?propertyTab=INVENTORY&unitName=${item.urlAlias}`;

    return (
        <TableCell className={`text-center !align-top`}>
            <Link to={itemUrl} onClick={() => refreshPage(itemUrl)}>
                <div className={"mb-3 font-semibold text-sm"}>{t(`dashboard.listing.menu.${item.resource}`)}</div>
                <div className="relative w-full min-h-[150px] flex items-center">
                    <LazyLoadImage
                        src={item.photo}
                        alt="property image"
                        title={`${item.title} photo`}
                        className="h-[150px] w-[250px] object-cover rounded"
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = `https://placehold.co/300x300?text=Zisla.com`;
                        }}
                    />
                </div>
                <div className="mt-3">
                    <div className="font-bold text-md">{item.title}</div>
                    <div className="text-sm">{item.address}</div>
                </div>
            </Link>
        </TableCell>
    );
}
